<template>
  <div class="page-container">
    <h2 class="message mb-2">Page Not Found</h2>
    <img class="image invert-on-darkmode mt-4" src="@/assets/404.png" />
  </div>
</template>

<script>
import Analytics from '@/lib/analytics'
export default {
  mounted() {
    Analytics.track('page view', {
      page: '404 page',
    })
  },
}
</script>
<style scoped>
.page-container {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: calc(100vh - 64px);
}
.message {
  font-family: var(--brand-font);
  font-weight: normal;
  text-transform: uppercase;
}

.image {
  width: 80%;
  max-width: 800px;
}
</style>
